import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { firebase } from "../../firebase";

const PrivateRoute = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = firebase.auth().onAuthStateChanged((authUser) => {
            setUser(authUser);
            setLoading(false);
            console.log('logged', authUser);
        });

        return () => unsubscribe();
    }, []);

    if (loading) return <p>Loading...</p>;

    return user ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
